'use strict';

var _classCallCheck = require("/opt/build/repo/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/opt/build/repo/node_modules/@babel/runtime/helpers/createClass.js");

var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray.js");

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopDefault(ex) {
  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}

var estreeWalker = require('estree-walker');

var is_reference = _interopDefault(require('is-reference')); // @ts-check

/** @typedef { import('estree').Node} Node */

/** @typedef { import('estree').VariableDeclaration} VariableDeclaration */

/** @typedef { import('estree').ClassDeclaration} ClassDeclaration */

/** @typedef { import('estree').VariableDeclarator} VariableDeclarator */

/** @typedef { import('estree').Property} Property */

/** @typedef { import('estree').RestElement} RestElement */

/** @typedef { import('estree').Identifier} Identifier */

/**
 *
 * @param {Node} expression
 */


function analyze(expression) {
  /** @type {WeakMap<Node, Scope>} */
  var map = new WeakMap();
  /** @type {Map<string, Node>} */

  var globals = new Map();
  var scope = new Scope(null, false);
  /** @type {[Scope, Identifier][]} */

  var references = [];
  var current_scope = scope;
  estreeWalker.walk(expression, {
    /**
     *
     * @param {Node} node
     * @param {Node} parent
     */
    enter: function enter(node, parent) {
      switch (node.type) {
        case 'Identifier':
          if (is_reference(node, parent)) {
            references.push([current_scope, node]);
          }

          break;

        case 'ImportDeclaration':
          node.specifiers.forEach(function (specifier) {
            current_scope.declarations.set(specifier.local.name, specifier);
          });
          break;

        case 'FunctionExpression':
        case 'FunctionDeclaration':
        case 'ArrowFunctionExpression':
          if (node.type === 'FunctionDeclaration') {
            if (node.id) {
              current_scope.declarations.set(node.id.name, node);
            }

            map.set(node, current_scope = new Scope(current_scope, false));
          } else {
            map.set(node, current_scope = new Scope(current_scope, false));

            if (node.type === 'FunctionExpression' && node.id) {
              current_scope.declarations.set(node.id.name, node);
            }
          }

          node.params.forEach(function (param) {
            extract_names(param).forEach(function (name) {
              current_scope.declarations.set(name, node);
            });
          });
          break;

        case 'ForStatement':
        case 'ForInStatement':
        case 'ForOfStatement':
          map.set(node, current_scope = new Scope(current_scope, true));
          break;

        case 'BlockStatement':
          map.set(node, current_scope = new Scope(current_scope, true));
          break;

        case 'ClassDeclaration':
        case 'VariableDeclaration':
          current_scope.add_declaration(node);
          break;

        case 'CatchClause':
          map.set(node, current_scope = new Scope(current_scope, true));

          if (node.param) {
            extract_names(node.param).forEach(function (name) {
              current_scope.declarations.set(name, node.param);
            });
          }

          break;
      }
    },

    /**
     *
     * @param {Node} node
     */
    leave: function leave(node) {
      if (map.has(node)) {
        current_scope = current_scope.parent;
      }
    }
  });

  for (var i = references.length - 1; i >= 0; --i) {
    var _references$i = _slicedToArray(references[i], 2),
        _scope = _references$i[0],
        reference = _references$i[1];

    if (!_scope.references.has(reference.name)) {
      add_reference(_scope, reference.name);

      if (!_scope.find_owner(reference.name)) {
        globals.set(reference.name, reference);
      }
    }
  }

  return {
    map: map,
    scope: scope,
    globals: globals
  };
}
/**
 *
 * @param {Scope} scope
 * @param {string} name
 */


function add_reference(scope, name) {
  scope.references.add(name);
  if (scope.parent) add_reference(scope.parent, name);
}

var Scope = /*#__PURE__*/function () {
  function Scope(parent, block) {
    _classCallCheck(this, Scope);

    /** @type {Scope | null} */
    this.parent = parent;
    /** @type {boolean} */

    this.block = block;
    /** @type {Map<string, Node>} */

    this.declarations = new Map();
    /** @type {Set<string>} */

    this.initialised_declarations = new Set();
    /** @type {Set<string>} */

    this.references = new Set();
  }
  /**
   *
   * @param {VariableDeclaration | ClassDeclaration} node
   */


  _createClass(Scope, [{
    key: "add_declaration",
    value: function add_declaration(node) {
      var _this = this;

      if (node.type === 'VariableDeclaration') {
        if (node.kind === 'var' && this.block && this.parent) {
          this.parent.add_declaration(node);
        } else {
          /**
           *
           * @param {VariableDeclarator} declarator
           */
          var handle_declarator = function handle_declarator(declarator) {
            extract_names(declarator.id).forEach(function (name) {
              _this.declarations.set(name, node);

              if (declarator.init) _this.initialised_declarations.add(name);
            });
          };

          node.declarations.forEach(handle_declarator);
        }
      } else if (node.id) {
        this.declarations.set(node.id.name, node);
      }
    }
    /**
     *
     * @param {string} name
     * @returns {Scope | null}
     */

  }, {
    key: "find_owner",
    value: function find_owner(name) {
      if (this.declarations.has(name)) return this;
      return this.parent && this.parent.find_owner(name);
    }
    /**
     *
     * @param {string} name
     * @returns {boolean}
     */

  }, {
    key: "has",
    value: function has(name) {
      return this.declarations.has(name) || !!this.parent && this.parent.has(name);
    }
  }]);

  return Scope;
}();
/**
 *
 * @param {Node} param
 * @returns {string[]}
 */


function extract_names(param) {
  return extract_identifiers(param).map(function (node) {
    return node.name;
  });
}
/**
 *
 * @param {Node} param
 * @param {Identifier[]} nodes
 * @returns {Identifier[]}
 */


function extract_identifiers(param) {
  var nodes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  switch (param.type) {
    case 'Identifier':
      nodes.push(param);
      break;

    case 'MemberExpression':
      var object = param;

      while (object.type === 'MemberExpression') {
        object =
        /** @type {any} */
        object.object;
      }

      nodes.push(
      /** @type {any} */
      object);
      break;

    case 'ObjectPattern':
      /**
       *
       * @param {Property | RestElement} prop
       */
      var handle_prop = function handle_prop(prop) {
        if (prop.type === 'RestElement') {
          extract_identifiers(prop.argument, nodes);
        } else {
          extract_identifiers(prop.value, nodes);
        }
      };

      param.properties.forEach(handle_prop);
      break;

    case 'ArrayPattern':
      /**
       *
       * @param {Node} element
       */
      var handle_element = function handle_element(element) {
        if (element) extract_identifiers(element, nodes);
      };

      param.elements.forEach(handle_element);
      break;

    case 'RestElement':
      extract_identifiers(param.argument, nodes);
      break;

    case 'AssignmentPattern':
      extract_identifiers(param.left, nodes);
      break;
  }

  return nodes;
}

exports.analyze = analyze;
exports.Scope = Scope;
exports.extract_names = extract_names;
exports.extract_identifiers = extract_identifiers;